import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import TopNav from './TopNav';
import ErrorBoundary from '../ui/ErrorBoundary';

export default function AppShell() {
  const { creator, token, loading, authError, retryAuth, logout } = useAuth();

  if (loading) {
    return (
      <div className="loading-state" style={{ minHeight: '100vh' }}>
        Loading...
      </div>
    );
  }

  if (!creator && token && authError) {
    return (
      <div className="login-screen">
        <div className="login-box">
          <div className="login-logo">TAKEOVER</div>
          <div className="login-sub">Creator Portal</div>
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <p style={{ color: 'var(--red)', fontFamily: "'Space Mono', monospace", fontSize: 11, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 24 }}>
              {authError}
            </p>
            <button className="login-btn primary" onClick={retryAuth}>
              Retry
            </button>
            <button className="topnav-mobile-logout" onClick={logout} style={{ marginTop: 12 }}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!creator) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="shell">
      <TopNav />
      <div className="main-content">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
}
